/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Drop_Files_Artifacts_Disabled_TitleInputs */



/**
* | output |
* | --- |
* | "Upload disabled" |
*
* @param {Spaces_Drop_Files_Artifacts_Disabled_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_drop_files_artifacts_disabled_title = /** @type {((inputs?: Spaces_Drop_Files_Artifacts_Disabled_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Drop_Files_Artifacts_Disabled_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upload deaktiviert")
	return /** @type {LocalizedString} */ ("Upload disabled")
});